import { useEffect, useRef, useState } from 'react';
import { isEqual } from 'lodash';

export default function useFormData(initialData) {
  const [formData, setFormData] = useState(initialData);
  const originalData = useRef({ ...initialData });
  const [outdated, setOutdated] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    if (!isEqual(initialData, originalData.current) && dirty) {
      setOutdated(true);
    } else {
      setOutdated(false);
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (field) => (event) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setFormData({ ...formData, [field]: value });
    if (!isEqual(value, originalData.current[field])) setDirty(true);
    else setDirty(false);
  };

  const handleAutocompleteChange = (field) => (_, newValue) => {
    let res;
    if (Array.isArray(newValue)) {
      res = newValue.map((item) => item._id);
    } else {
      res = newValue?._id;
    }
    setFormData({ ...formData, [field]: res });
    setDirty(true);
  };

  const handleDateChange = (field) => (newValue) => {
    const updatedValue = newValue
      ? (newValue.toISOString?.() ?? newValue)
      : null;

    setFormData((prev) => ({
      ...prev,
      [field]: updatedValue,
    }));

    if (!isEqual(updatedValue, originalData.current[field])) {
      setDirty(true);
    } else {
      setDirty(false);
    }
  };

  const reset = () => {
    setFormData(initialData);
    setDirty(false);
    setOutdated(false);
  };
  const setUpdated = () => {
    setDirty(false);
    setOutdated(false);
  };

  return {
    formData,
    setFormData,
    handleChange,
    handleAutocompleteChange,
    handleDateChange,
    reset,
    outdated,
    dirty,
    setUpdated,
  };
}
